import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

interface UserOptionalDetailsProps {
  street: string;
  postcode: string;
  companyName: string;
  position: string;
  industry: string;
  country: string;
  mobileNumber: string;
  setStreet: (street: string) => void;
  setPostcode: (postcode: string) => void;
  setCompanyName: (company: string) => void;
  setPosition: (position: string) => void;
  setIndustry: (industry: string) => void;
  setCountry: (country: string) => void;
  setMobileNumber: (mobile: string) => void;
}

export default function UserOptionalDetails({
  street,
  postcode,
  companyName,
  position,
  industry,
  country,
  mobileNumber,
  setStreet,
  setPostcode,
  setCompanyName,
  setPosition,
  setIndustry,
  setCountry,
  setMobileNumber,
}: UserOptionalDetailsProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Box display={"flex"} gap={"1rem"} marginBlock={"1rem"} flexWrap={"wrap"}>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>{t("regiolux:dialog.requestQuote.street")}</Typography>
        <TextField
          value={street}
          onChange={(event) => setStreet(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>{t("regiolux:dialog.requestQuote.postcode")}</Typography>
        <TextField
          value={postcode}
          onChange={(event) => setPostcode(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>{t("regiolux:dialog.requestQuote.company")}</Typography>
        <TextField
          value={companyName}
          onChange={(event) => setCompanyName(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>{t("regiolux:dialog.requestQuote.position")}</Typography>
        <TextField
          value={position}
          onChange={(event) => setPosition(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>{t("regiolux:dialog.requestQuote.industry")}</Typography>
        <TextField
          value={industry}
          onChange={(event) => setIndustry(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>{t("regiolux:dialog.requestQuote.country")}</Typography>
        <TextField
          value={country}
          onChange={(event) => setCountry(event.target.value)}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        flexBasis={"calc(50% - 0.5rem)"}
      >
        <Typography>
          {t("regiolux:dialog.requestQuote.mobileNumber")}
        </Typography>
        <TextField
          value={mobileNumber}
          onChange={(event) => setMobileNumber(event.target.value)}
        />
      </Box>
    </Box>
  );
}
